import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { USE_SITE_MERGE_TOOL_LINK } from './constants'
import { operations } from '../../redux/sitesManager'
import { siteOrgNetSuiteCustomerSearch } from '../../redux/sitesManager/operations'
import EditSiteModal from './component'
import {
  formatSiteForSchoolLookUp,
  formatNetsuiteCustomerForSchoolLookUp,
  searchNSCustomersDebounced,
} from '../../lib/editNetSuite'

const EditSiteModalContainer = ({ isOpen, site, toggle, updateSite }) => {
  const [currentSchool, setCurrentSchool] = useState()
  // this value is the nsCustomerId which the user types in
  const [previousCustomerId, setPreviousCustomerId] = useState('')
  const [
    previousCustomerIdValidation,
    setPreviousCustomerIdValidation,
  ] = useState('')

  const { netSuiteCustomer } = site || {}
  const { nsCustomerId = '', companyName = '' } = netSuiteCustomer || {}
  const { organization } = site || {}
  const assignedTo = organization.name || ''

  useEffect(() => {
    setCurrentSchool(formatSiteForSchoolLookUp(site))
  }, [])

  const customerIdValidateAsync = (value, formik) => {
    try {
      if (value === previousCustomerId) {
        return previousCustomerIdValidation
      }
      if (!value) {
        return
      }

      const formattedValue = value.toString()
      if (!formattedValue.match(/^[0-9]*$/)) {
        const formatErrorMessage = 'Customer Id must contain only numbers'
        setPreviousCustomerId(value)
        setPreviousCustomerIdValidation(formatErrorMessage)
        return formatErrorMessage
      }

      let errorMessage

      const duplicateCheck = siteOrgNetSuiteCustomerSearch({
        nsCustomerId: value,
        orgId: site.organizationId,
      })
        .then(res => {
          const nsCustomerOf = res.data.filter(
            s => s.id !== site.id && s.organizationId === site.organizationId,
          )

          if (nsCustomerOf.length > 0) {
            errorMessage = `Customer Id ${value} ` + USE_SITE_MERGE_TOOL_LINK
            setPreviousCustomerId(value)
            setPreviousCustomerIdValidation(errorMessage)
          }
        })
        .catch(err => (errorMessage = err.message))

      const validate = searchNSCustomersDebounced(value)
        .then(response => {
          const school = response.data[0]
          if (school) {
            const formattedSchool = formatNetsuiteCustomerForSchoolLookUp(
              school,
            )
            schoolSelected(formik, formattedSchool)
            setCurrentSchool(formattedSchool)
          } else {
            errorMessage = `Cannot find Customer Id ${value}`
          }
          setPreviousCustomerId(value)
          setPreviousCustomerIdValidation(errorMessage)
        })
        .catch(err => err.message)

      return Promise.allSettled([duplicateCheck, validate]).then(
        checks => errorMessage,
      )
    } catch (err) {
      setPreviousCustomerId(value)
      setPreviousCustomerIdValidation(err.message)
      return err.message
    }
  }

  const setValue = async (formik, fieldName, value, validate = true) =>
    await formik.setFieldValue(fieldName, value, validate)

  const schoolSelected = async (formik, site) => {
    const {
      city,
      companyName,
      country,
      netsuiteCustomerId,
      nsCustomerId,
      organizationName,
      region,
    } = site

    await setValue(formik, 'city', city)
    await setValue(formik, 'companyName', companyName)
    await setValue(formik, 'country', country)
    await setValue(formik, 'netsuiteCustomerId', netsuiteCustomerId)
    await setValue(formik, 'nsCustomerId', nsCustomerId)
    await setValue(formik, 'region', region)
    await setValue(formik, 'organizationName', organizationName)

    setCurrentSchool(site)
  }

  const handleSubmit = async (values, { setSubmitting }) => {
    const updatedSite = {
      address: {
        city: currentSchool.city,
        country: currentSchool.country,
        region: currentSchool.region,
      },
      id: site.id,
      isRostered: site.isRostered,
      organizationId: values.organizationId,
      name: currentSchool.companyName || currentSchool.organizationName,
      netsuiteCustomerId: currentSchool.netsuiteCustomerId,
    }

    await updateSite(updatedSite)
    toggle()
    setSubmitting(false)
  }

  return (
    <EditSiteModal
      assignedTo={assignedTo}
      companyName={companyName}
      currentSchool={currentSchool}
      customerIdValidateAsync={customerIdValidateAsync}
      handleSubmit={handleSubmit}
      isOpen={isOpen}
      nsCustomerId={nsCustomerId}
      schoolSelected={schoolSelected}
      site={site}
      toggle={toggle}
    />
  )
}

EditSiteModalContainer.propTypes = {
  isOpen: PropTypes.bool,
  site: PropTypes.object,
  toggle: PropTypes.func,
  updateSite: PropTypes.func,
}

const mapDispatchToProps = {
  ...operations,
}

export default connect(null, mapDispatchToProps)(EditSiteModalContainer)



// WEBPACK FOOTER //
// ./src/components/EditSiteModal/container.js